<template>
  <div class="supplier_network_form">
    <div class="eb_review_info" v-if="show_data_table">
      <div class="info_title">基本信息</div>
      <el-form label-width="160px" class="eb_review_form">
        <el-form-item label="公司类型：">{{ company_type_name }}</el-form-item>
        <el-form-item label="入网状态：" v-if="supplier_info.applicationStatus">
          {{ review_status_hash[supplier_info.applicationStatus] }}{{ supplier_info.applicationStatus }}
        </el-form-item>
        <el-form-item label="入网状态：" v-if="!supplier_info.applicationStatus">待入网</el-form-item>
        <el-form-item label="申请驳回原因：" v-if="supplier_info.applicationStatus == 'REVIEW_BACK'">
          {{ supplier_info.auditOpinion }}
        </el-form-item>
      </el-form>
    </div>
    <div class="eb_review_info" v-if="show_data_table">
      <div class="info_title">其它信息</div>
    </div>
    <el-form :model="show_form" :rules="rules" ref="networkForm" label-width="160px">
      <div class="col_2">
        <el-form-item label="公司类型：" prop="show_store_type">
          <el-select
            v-model="show_form.show_store_type"
            placeholder="请选择"
            @change="changeStoreType"
            :disabled="supplier_info.pid || (supplier_info.store_net_info && supplier_info.store_net_info.id) ? true : false"
          >
            <el-option v-for="item in store_type_list" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="法人姓名：" prop="legalName" v-if="show_form.show_store_type != 3" key="legalName12">
          <el-input :disabled="!is_edit" v-model="show_form.legalName" placeholder="请输入" />
        </el-form-item>
      </div>
      <el-form-item label="身份证姓名：" prop="legalName" v-if="show_form.show_store_type == 3" key="legalName3">
        <el-input :disabled="!is_edit" v-model="show_form.legalName" placeholder="请输入" />
      </el-form-item>
      <div class="col_2">
        <el-form-item label="统一社会信用代码：" v-if="show_form.licenceNo !== undefined" prop="licenceNo" key="licenceNo12">
          <el-input :disabled="!is_edit" v-model="show_form.licenceNo" placeholder="请输入" />
        </el-form-item>
        <el-form-item label="法人身份证号：" prop="legalLicenceNo" key="legalLicenceNo12">
          <el-input :disabled="!is_edit" v-model="show_form.legalLicenceNo" placeholder="请输入" />
        </el-form-item>
      </div>
      <div class="col_2">
        <el-form-item label="营业执照名称：" prop="signName" v-if="show_form.signName !== undefined" key="signName12">
          <el-input :disabled="!is_edit" v-model="show_form.signName" placeholder="请输入" />
        </el-form-item>
        <el-form-item label="联系人：" v-if="show_form.contactName !== undefined" prop="contactName" key="contactName12">
          <el-input :disabled="!is_edit" v-model="show_form.contactName" placeholder="请输入" />
        </el-form-item>
      </div>
      <el-form-item label="联系人手机号：" v-if="show_form.show_store_type == 3" prop="contactMobile" key="contactMobile3">
        <el-input :disabled="!is_edit" v-model="show_form.contactMobile" placeholder="请输入" />
      </el-form-item>
      <div class="col_2">
        <el-form-item label="银行账户开户支行：" prop="cnapsCode" key="cnapsCode12">
          <el-select filterable :filter-method="filterBankSelect" v-model="show_form.cnapsCode" placeholder="请选择" v-more="getMoreBankList" :clearable="true" :disabled="!is_edit">
            <el-option v-for="(option, index) in bank_list_config.list" :key="index" :label="option.bank_name" :value="option.bank_yeath_code"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="联系人手机号：" v-if="show_form.show_store_type != 3" prop="contactMobile" key="contactMobile12">
          <el-input :disabled="!is_edit" v-model="show_form.contactMobile" placeholder="请输入" />
        </el-form-item>
      </div>
      <el-form-item label="银行账户类型：" prop="bankAccountType" key="bankAccountType12">
        <el-select :disabled="!is_edit" v-model="show_form.bankAccountType" placeholder="请选择">
          <el-option v-for="item in bankAccountTypeList" :key="item.dict_value" :label="item.description" :value="item.dict_value" />
        </el-select>
      </el-form-item>
      <el-form-item label="银行账户：" prop="bankCardNo" key="bankCardNo12">
        <el-input :disabled="!is_edit" v-model="show_form.bankCardNo" placeholder="请输入" />
      </el-form-item>
      <el-form-item label="公司地址：" prop="choose_area" key="choose_area12">
        <div class="address_box">
          <el-cascader ref="cascaderRef" v-model="show_form.choose_area" :options="area_list" :props="area_props" placeholder="请选择省市区" :disabled="!is_edit"></el-cascader>
          <el-input class="mg4" v-model="show_form.address" type="textarea" placeholder="请输入详细地址" rows="4" :disabled="!is_edit" />
        </div>
      </el-form-item>
      <el-form-item label="上传图片：" :prop="show_form.show_store_type != 3 ? 'enterprise_form_img' : 'mini_form_img'" key="uploadImgs12">
        <div class="upload_imgs">
          <!-- 营业执照 -->
          <div class="licence_url_box" v-if="show_form.licenceUrl !== undefined">
            <div class="title">营业执照：</div>
            <ReadyUploadSource
              :path="show_form.licenceUrl"
              @getSource="getLicenceUrl"
              @removeThis="show_form.licenceUrl = ''"
              :maxSize="6 * 1024 * 1024"
              type="eb"
              :disabled="!is_edit"
            ></ReadyUploadSource>
            <div class="tips">图片大小不超过6m</div>
          </div>
          <!-- 法人身份证正面照 -->
          <div class="licence_url_box">
            <div class="title">法人身份证正面照：</div>
            <ReadyUploadSource
              :path="show_form.legalLicenceFrontUrl"
              @getSource="getLegalLicenceFrontUrl"
              @removeThis="show_form.legalLicenceFrontUrl = ''"
              :maxSize="6 * 1024 * 1024"
              type="eb"
              :disabled="!is_edit"
            ></ReadyUploadSource>
            <div class="tips">图片大小不超过6m</div>
          </div>
          <!-- 法人身份证反面照 -->
          <div class="licence_url_box">
            <div class="title">法人身份证反面照：</div>
            <ReadyUploadSource
              :path="show_form.legalLicenceBackUrl"
              @getSource="getLegalLicenceBackUrl"
              @removeThis="show_form.legalLicenceBackUrl = ''"
              :maxSize="6 * 1024 * 1024"
              type="eb"
              :disabled="!is_edit"
            ></ReadyUploadSource>
            <div class="tips">图片大小不超过6m</div>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="开户许可证：" v-if="show_form.openAccountLicenceUrl !== undefined" key="openAccountLicenceUrl12">
        <div class="upload_imgs">
          <div class="licence_url_box">
            <ReadyUploadSource
              :path="show_form.openAccountLicenceUrl"
              @getSource="getOpenAccountLicenceUrl"
              @removeThis="show_form.openAccountLicenceUrl = ''"
              :maxSize="6 * 1024 * 1024"
              type="eb"
              :disabled="!is_edit"
            ></ReadyUploadSource>
            <div class="tips">1、如果无法提供开户许可证,可提供基本存款账户信息、印鉴卡、结算账户开户回执单、银行电子回单、企业网银登录截图</div>
            <div class="tips">2、当商户类型为个体工商户时，还可以上传结算银行卡照片</div>
          </div>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import common_data from '@/util/common_data.js';
import { debounce } from '@/util/util.js';
import InfiniteScroll from '@/directives/infiniteScroll.js';
import $axios from '@/util/axios.js';
import $api from '@/util/api.js';
import ReadyUploadSource from '@/components/readyUploadSource.vue';
import _ from 'lodash';
import { inspectPhone, isValidBusinessLicense } from '@/util/verification.js';

export default {
  props: {
    supplier_info: {
      type: Object,
      default: () => {},
    },
    is_edit: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    ReadyUploadSource,
  },
  directives: {
    more: InfiniteScroll,
  },
  data() {
    const checkAreaData = (rule, value, callback) => {
      if (!value || value.length === 0) {
        callback(new Error('请选择省市区'));
      } else if (!this.show_form.address) {
        callback(new Error('请输入详细地址'));
      } else {
        callback();
      }
    };
    const checkEnterpriseImgsData = (rule, value, callback) => {
      if (!this.show_form.licenceUrl) {
        callback(new Error('请上传营业执照'));
      }
      if (!this.show_form.legalLicenceFrontUrl) {
        callback(new Error('请上传法人身份证正面照'));
      }
      if (!this.show_form.legalLicenceBackUrl) {
        callback(new Error('请上传法人身份证反面照'));
      }
      callback();
    };
    const checkMiniImgsData = (rule, value, callback) => {
      if (!this.show_form.legalLicenceFrontUrl) {
        callback(new Error('请上传法人身份证正面照'));
      }
      if (!this.show_form.legalLicenceBackUrl) {
        callback(new Error('请上传法人身份证反面照'));
      }
      callback();
    };
    const checkPhone = (rule, value, callback) => {
      if (!inspectPhone(value)) {
        callback(new Error('请输入正确的手机号'));
      } else {
        callback();
      }
    };
    const checkValidBusinessLicense = (rule, value, callback) => {
      if (!isValidBusinessLicense(value)) {
        callback(new Error('请输入正确的统一社会信用代码'));
      } else {
        callback();
      }
    };
    return {
      store_type_list: common_data.new_store_type,
      // eb 公司类型
      signType: '',
      // 企业/个人 表单
      enterprise_form: {
        // 统一社会信用代码
        licenceNo: '',
        licenceUrl: '',
        // 营业执照名称
        signName: '',
        // 银行账户开户支行
        cnapsCode: '',
        // 银行账户类型
        bankAccountType: '',
        // 银行账户
        bankCardNo: '',
        choose_area: [],
        province: '',
        city: '',
        district: '',
        address: '',
        // 法人姓名
        legalLicenceType: 'ID_CARD',
        legalName: '',
        legalLicenceNo: '',
        // 法人身份证
        legalLicenceFrontUrl: '',
        legalLicenceBackUrl: '',
        // 开户许可证
        openAccountLicenceUrl: '',
        contactName: '',
        contactMobile: '',
        enterprise_form_img: '',
        settlementDirection: 'BANKCARD',
      },
      // 小微表单
      mini_form: {
        legalName: '',
        legalLicenceType: 'ID_CARD',
        legalLicenceNo: '',
        legalLicenceFrontUrl: '',
        legalLicenceBackUrl: '',
        choose_area: [],
        province: '',
        city: '',
        district: '',
        address: '',
        contactMobile: '',
        cnapsCode: '',
        bankAccountType: '',
        bankCardNo: '',
        mini_form_img: '',
        settlementDirection: 'BANKCARD',
      },
      show_form: {
        // 公司类型
        show_store_type: 1,
      },
      rules: {},
      all_rules: {
        show_store_type: [{ required: true, message: '请选择公司类型', trigger: 'change' }],
        licenceNo: [
          {
            required: true,
            message: '请输入统一社会信用代码',
            trigger: 'blur',
          },
          { validator: checkValidBusinessLicense, trigger: 'blur' },
        ],
        signName: [{ required: true, message: '请输入营业执照名称', trigger: 'blur' }],
        cnapsCode: [
          {
            required: true,
            message: '请选择银行账户开户支行',
            trigger: 'change',
          },
        ],
        bankAccountType: [{ required: true, message: '请选择银行账户类型', trigger: 'change' }],
        bankCardNo: [{ required: true, message: '请输入银行账户', trigger: 'blur' }],
        choose_area: [
          { required: true, message: '请选择省市区', trigger: 'change' },
          { validator: checkAreaData, trigger: 'blur' },
        ],
        legalName: [{ required: true, message: '请输入法人姓名', trigger: 'blur' }],
        legalLicenceNo: [{ required: true, message: '请输入法人身份证号', trigger: 'blur' }],
        contactName: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
        contactMobile: [
          { required: true, message: '请输入联系人手机号', trigger: 'blur' },
          { validator: checkPhone, trigger: 'blur' },
        ],
        enterprise_form_img: [
          { required: true, message: '请上传必传图片' },
          { validator: checkEnterpriseImgsData, trigger: 'change' },
        ],
        mini_form_img: [
          { required: true, message: '请上传必传图片' },
          { validator: checkMiniImgsData, trigger: 'change' },
        ],
      },
      bankAccountTypeList: [],
      bank_list_config: {
        page: 1,
        rows: 20,
        list: [],
        is_more: true,
        bank_name: '',
      },
      area_list: [],
      area_props: {
        lazy: true,
        value: 'id',
        label: 'name',
        lazyLoad(node, resolve) {
          const { level, data } = node;
          if (level <= 2 && level > 0) {
            $axios.get($api.set.area, { pid: data.id }).then((res) => {
              if (res.code == 0) {
                res.result.list.forEach((item) => {
                  item.leaf = level < 2 ? false : true;
                });
                resolve(res.result.list);
              }
            });
          }
        },
      },
      eb_images: {
        legalLicenceFrontUrl: '',
        legalLicenceBackUrl: '',
        licenceUrl: '',
        openAccountLicenceUrl: '',
      },
      review_status_hash: {},
      signTypeHash: {},
    };
  },
  computed: {
    filterBankSelect() {
      return debounce((val) => {
        this.bank_list_config.bank_name = val;
        this.bank_list_config.page = 1;
        this.bank_list_config.list = [];
        this.getBankSelect();
      }, 300);
    },
    show_data_table() {
      let flag = false;
      if (this.$route.path == '/supplier/edit' || this.$route.path == '/supplier/info') {
        flag = true;
      }
      return flag;
    },
    company_type_name() {
      let i = this.store_type_list.find((item) => item.id == this.show_form.show_store_type);
      if (i) return i.name;
      return '';
    },
  },
  methods: {
    getLegalLicenceBackUrl(val) {
      this.eb_images.legalLicenceBackUrl = val.eb;
      this.show_form.legalLicenceBackUrl = val.path;
    },
    getOpenAccountLicenceUrl(val) {
      this.eb_images.openAccountLicenceUrl = val.eb;
      this.show_form.openAccountLicenceUrl = val.path;
    },
    getLicenceUrl(val) {
      this.eb_images.licenceUrl = val.eb;
      this.show_form.licenceUrl = val.path;
    },
    getLegalLicenceFrontUrl(val) {
      this.eb_images.legalLicenceFrontUrl = val.eb;
      this.show_form.legalLicenceFrontUrl = val.path;
    },
    getMoreBankList() {
      this.bank_list_config.page++;
      this.getBankSelect();
    },
    getBankSelect(cnapsCode) {
      let obj = {};
      obj = {
        page: this.bank_list_config.page,
        rows: this.bank_list_config.rows,
      };
      if (this.bank_list_config.bank_name) {
        obj.bank_name = this.bank_list_config.bank_name;
      }
      if (cnapsCode) {
        obj.bank_yeath_code = cnapsCode;
      }
      this.$axios.post(this.$api.supplier.bank_code_list, obj).then((res) => {
        if (res.code == 0) {
          this.bank_list_config.list.push(...res.result.list);
          if (res.result.list.length < obj.rows) {
            this.bank_list_config.is_more = false;
          }
        }
      });
    },
    handleInitForm(new_store_type) {
      let s_type = new_store_type || this.show_form.show_store_type;
      let target_form = s_type == 1 || s_type == 2 ? _.cloneDeep(this.enterprise_form) : _.cloneDeep(this.mini_form);
      for (const key in target_form) {
        if (this.show_form[key]) target_form[key] = this.show_form[key];
      }
      this.show_form = { ...target_form };
      this.show_form.show_store_type = s_type;
      // 初始化表单规则
      this.rules = {};
      for (const key in this.show_form) {
        if (this.all_rules[key]) {
          this.rules[key] = this.all_rules[key];
        }
      }
      this.rules.show_store_type = this.all_rules.show_store_type;
    },
    getAreaList(pid, callback = () => {}) {
      let obj = {};
      if (pid) obj = pid;
      this.$axios.get(this.$api.set.area, obj).then((res) => {
        if (res.code == 0) {
          if (!pid) this.area_list = res.result.list;
          if (pid) {
            callback(res.result.list);
          }
        }
      });
    },
    changeStoreType() {
      this.handleInitForm(this.show_form.show_store_type);
    },
    dealImageCheck() {
      if (this.show_form.legalLicenceFrontUrl && this.show_form.legalLicenceBackUrl) {
        if (this.show_form.show_store_type != 3 && this.show_form.licenceUrl) {
          this.show_form.enterprise_form_img = 1;
        }
        if (this.show_form.show_store_type == 3) {
          this.show_form.mini_form_img = 1;
        }
      }
    },
    submitNetworkInfo(callback = () => {}) {
      this.dealImageCheck();
      this.$refs.networkForm.validate((valid) => {
        if (valid) {
          let obj = _.cloneDeep(this.show_form);
          obj.new_store_type = obj.show_store_type;
          delete obj.show_store_type;
          obj.sign_type = obj.sign_type || '';
          obj.province = obj.choose_area[0];
          obj.city = obj.choose_area[1];
          obj.district = obj.choose_area[2];
          delete obj.choose_area;
          let url = this.$api.supplier.addStoreNetInfo;
          if (obj.show_store_type == 3) {
            delete obj.mini_form_img;
          }
          if (obj.show_store_type == 1 || obj.show_store_type == 2) {
            delete obj.enterprise_form_img;
          }
          obj.store_id = this.supplier_info.id;
          obj.store_user_id = this.supplier_info.store_user_id;
          if (obj.legalLicenceFrontUrl) {
            obj.legalLicenceFrontUrl = this.eb_images.legalLicenceFrontUrl;
          }
          if (obj.legalLicenceBackUrl) {
            obj.legalLicenceBackUrl = this.eb_images.legalLicenceBackUrl;
          }
          if (obj.licenceUrl) {
            obj.licenceUrl = this.eb_images.licenceUrl;
          }
          if (obj.openAccountLicenceUrl) {
            obj.openAccountLicenceUrl = this.eb_images.openAccountLicenceUrl;
          }
          if (this.supplier_info.store_net_info.id) {
            url = this.$api.supplier.editStoreNetInfo;
          }
          this.$axios.post(url, obj).then((res) => {
            if (res.code == 0) {
              this.$message({
                message: this.supplier_info.store_net_info.id ? '编辑成功' : '新增成功',
                type: 'success',
              });
              callback();
            }
          });
        } else {
          return false;
        }
      });
    },
    setFormData() {
      this.handleInitForm(this.supplier_info.store_net_info.new_store_type);
      let obj = this.supplier_info.store_net_info;
      let that = this;
      for (const key in this.show_form) {
        if (key == 'cnapsCode') {
          this.$nextTick(() => {
            this.show_form[key] = obj.cnapsCode || '';
            this.bank_list_config.bank_name = '';
            this.bank_list_config.page = 1;
            this.bank_list_config.list = [];
            this.getBankSelect(obj.cnapsCode);
          });
          continue;
        }
        if (key == 'show_store_type') {
          this.show_form[key] = obj.new_store_type;
          continue;
        }
        if (key == 'choose_area') {
          this.$set(this.show_form, 'choose_area', [parseFloat(obj.province), parseFloat(obj.city), parseFloat(obj.district)]);
          continue;
        }
        if (key == 'legalLicenceBackUrl') {
          this.show_form[key] = obj.new_legalLicenceBackUrl;
          this.eb_images[key] = obj[key];
          continue;
        }
        if (key == 'legalLicenceFrontUrl') {
          this.show_form[key] = obj.new_legalLicenceFrontUrl;
          this.eb_images[key] = obj[key];
          continue;
        }
        if (key == 'licenceUrl') {
          this.show_form[key] = obj.new_licenceUrl;
          this.eb_images[key] = obj[key];
          continue;
        }
        if (key == 'openAccountLicenceUrl') {
          this.show_form[key] = obj.new_openAccountLicenceUrl;
          this.eb_images[key] = obj[key];
          continue;
        }
        this.show_form[key] = obj[key];
      }
      // 更新地图组件
      if (obj.province) {
        this.getAreaList({ pid: parseFloat(obj.province), level: 1 }, (res) => {
          let p = that.area_list.find((item) => item.id == parseFloat(obj.province));
          that.$set(p, 'children', res);
          that.getAreaList({ pid: parseFloat(obj.city), level: 2 }, (area) => {
            area.forEach((item) => {
              item.leaf = true;
            });
            let c = p.children.find((item) => item.id == parseFloat(obj.city));
            that.$set(c, 'children', area);
            // 确保级联选择器更新
            that.$refs.cascaderRef && that.$refs.cascaderRef.$forceUpdate();
          });
        });
      }
      this.dealImageCheck();
    },
  },
  created() {
    this.getBankSelect();
    this.$store.dispatch('basic/getPayHash', { type: 'BANKACCOUNTTYPE' }).then((res) => {
      this.bankAccountTypeList = res;
    });
    this.$store.dispatch('basic/getPayHash', { type: 'APPLICATIONSTATUS' }).then((res) => {
      res.forEach((item) => {
        this.review_status_hash[item.dict_value] = item.description;
      });
    });
    this.$store.dispatch('basic/getPayHash', { type: 'SIGNTYPE' }).then((res) => {
      res.forEach((item) => {
        this.signTypeHash[item.dict_value] = item.description;
      });
    });
    this.getAreaList();
    // 新增供应商
    if(this.$route.path == '/supplier/add'){
      this.handleInitForm(1)
    }
  },
};
</script>

<style lang="less" scoped>
.supplier_network_form{
  width: fit-content  ;
}
.eb_review_info {
  width: 100%;
  .info_title {
    line-height: 40px;
    border-bottom: 1px solid #ebeef5;
    margin-bottom: 12px;
  }
  .eb_review_form {
    .el-form-item {
      margin-bottom: 0 !important;
    }
  }
}
.el-input,
.el-select,
.el-cascader {
  width: 300px;
}
.el-textarea {
  width: 300px;
}
.col_2 {
  width: 1100px;
  display: flex;
  .el-form-item {
    width: 50%;
  }
}
.mg4 {
  margin-top: 4px;
}
.address_box {
  display: flex;
  flex-direction: column;
}
.upload_imgs {
  display: flex;
  align-items: flex-start;
  .licence_url_box {
    display: flex;
    flex-direction: column;
    margin-right: 20px;
    .title {
      font-size: 14px;
      color: #303133;
    }
    .tips {
      font-size: 12px;
      color: #606266;
    }
  }
}
</style>
